import { i18n } from '../lang'

export const genders = [
  { value: 'W', label: i18n.t('common.women') },
  { value: 'M', label: i18n.t('common.men') },
  { value: 'K', label: i18n.t('common.kids') },
]
export const userTypes = [
  { value: 0, label: i18n.t('userType.all') },
  { value: 1, label: i18n.t('userType.members') },
  { value: 2, label: i18n.t('userType.guests') },
]

export const getDefaultPromotionDetail = (isAutoFill = false, detail = null) => ({
  button: isAutoFill ? 'Shop Now' : '',
  button_th_th: isAutoFill ? 'ช้อปเลย' : '',
  button_zh_cn: isAutoFill ? '选购' : '',
  button_zh_hk: isAutoFill ? '選購' : '',
  main_img: (isAutoFill && detail !== null) ? detail.img : '',
  status: false,
  target_user_type: 0,
  title: isAutoFill ? 'Today\'s Deal' : '',
  title_th_th: isAutoFill ? 'ดีลประจำวัน' : '',
  title_zh_cn: isAutoFill ? '今日优惠' : '',
  title_zh_hk: isAutoFill ? '今日優惠' : '',
  txt_1: (isAutoFill && detail !== null) ? detail.title : '',
  txt_1_th_th: (isAutoFill && detail !== null) ? detail.title_th_th : '',
  txt_1_zh_cn: (isAutoFill && detail !== null) ? detail.title_zh_cn : '',
  txt_1_zh_hk: (isAutoFill && detail !== null) ? detail.title_zh_hk : '',
  txt_2: (isAutoFill && detail !== null) ? detail.desc : '',
  txt_2_th_th: (isAutoFill && detail !== null) ? detail.desc_th_th : '',
  txt_2_zh_cn: (isAutoFill && detail !== null) ? detail.desc_zh_cn : '',
  txt_2_zh_hk: (isAutoFill && detail !== null) ? detail.desc_zh_hk : '',
})
